import * as React from 'react'

function IconTelegram(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={43}
      height={35}
      viewBox="0 0 43 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.635 15.243L28.25 4.853C30.777 3.772 39.352.31 39.352.31s3.959-1.515 3.628 2.163c-.11 1.515-.99 6.817-1.869 12.553l-2.748 16.99s-.22 2.489-2.089 2.922c-1.868.432-4.946-1.515-5.497-1.948-.44-.324-8.244-5.194-11.103-7.575-.768-.649-1.648-1.948.11-3.463 3.958-3.57 8.685-8.007 11.542-10.821 1.32-1.299 2.64-4.329-2.858-.649L12.969 20.762s-1.758 1.083-5.056.108C4.615 19.896.767 18.598.767 18.598s-2.639-1.624 1.868-3.355z"
        fill="#C4C4C4"
      />
    </svg>
  )
}

export default IconTelegram
